import { useHistory } from 'react-router-dom';
import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import React, { useContext, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';

import Header from '../../components/Header';
import { ctx, IStore } from '../../store';

import { useStyles } from './styles';

function not(a: number[], b: number[]) {
  return a.filter(value => b.indexOf(value) === -1);
}

function intersection(a: number[], b: number[]) {
  return a.filter(value => b.indexOf(value) !== -1);
}

function union(a: number[], b: number[]) {
  return [...a, ...not(b, a)];
}

const Preset: React.FC = () => {
  const history = useHistory();
  const {
    teams: { currentTeam },
  } = useContext(ctx.store);
  const actions = useContext(ctx.actions);
  const classes = useStyles();
  const [checked, setChecked] = React.useState<any[]>([]);
  const [left, setLeft] = React.useState<any[]>([]);
  const [right, setRight] = React.useState<any[]>([]);
  const [team, setCurrentTeam] = React.useState<any>();

  function isNotArchived(ch: any, index: number) {
    if (!ch.isArchived) {
      return index;
    }
  }

  function isNotDeleted(gr: any, index: number) {
    if (!gr.deleted) {
      return index;
    }
  }

  useEffect(() => {
    document.title = 'Sensla | Analysis for a Great Environment';
    if (!currentTeam) {
      const savedTeam = localStorage.getItem('team');
      if (!savedTeam) {
        history.push('/home');
      } else {
        const parsedSavedTeam = JSON.parse(savedTeam);
        if (!parsedSavedTeam.preset) {
          setTeam(parsedSavedTeam);
          setCurrentTeam(parsedSavedTeam);
          if (parsedSavedTeam.teamId) {
            setLeft(
              parsedSavedTeam.channels
                .map(isNotArchived)
                .filter((channel: any) => channel || channel === 0)
            );
          } else {
            setLeft(
              parsedSavedTeam.msGroups
                .map(isNotDeleted)
                .filter((group: any) => group || group === 0)
            );
          }
        } else {
          history.push('/home');
        }
      }
    } else {
      if (currentTeam.preset) {
        history.push('/home');
      } else {
        setCurrentTeam(currentTeam);
        if (currentTeam.teamId) {
          setLeft(
            currentTeam.channels
              .map(isNotArchived)
              .filter((channel: any) => channel || channel === 0)
          );
        } else {
          setLeft(
            currentTeam.msGroups.map(isNotDeleted).filter((group: any) => group || group === 0)
          );
        }
      }
    }
  }, []);

  const setTeam = async (team: string) => {
    await ((actions.teams.setCurrentTeam(team) as unknown) as Promise<IStore>);
  };

  const handleSubmit = async () => {
    await ((actions.misc.setLoading(true) as unknown) as Promise<IStore>);
    if (currentTeam.teamId) {
      const channels = team.channels
        .map((ch: any, index: number) => {
          if (right.includes(index)) {
            return ch.channelId;
          }
        })
        .filter((e: any) => e);
      const data = { channels, team: team.teamId };
      const response = await ((actions.teams.channelsJoin(data) as unknown) as Promise<IStore>);
      if (response.misc.notification.type === 'success') {
        history.push('/dashboard');
      }
    } else {
      const groups = team.msGroups
        .map((group: any, index: number) => {
          if (right.includes(index)) {
            return group.groupId;
          }
        })
        .filter((e: any) => e);
      const data = { groups, tenant: team.tenantId };
      const response = await ((actions.tenants.groupsJoin(data) as unknown) as Promise<IStore>);
      if (response.misc.notification.type === 'success') {
        history.push('/dashboard');
      }
    }
  };

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value: number) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items: number[]) => intersection(checked, items).length;

  const handleToggleAll = (items: number[]) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const customList = (title: React.ReactNode, items: number[]) => (
    <Card>
      <CardHeader
        className={classes.cardHeader}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={numberOfChecked(items) === items.length && items.length !== 0}
            indeterminate={numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0}
            disabled={items.length === 0}
            inputProps={{ 'aria-label': 'all items selected' }}
            color="primary"
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} selected`}
      />
      <Divider />
      <List className={classes.list} dense component="div" role="list">
        {items.map((value: number) => {
          const labelId = `transfer-list-all-item-${value}-label`;

          return (
            <ListItem key={value} role="listitem" button onClick={handleToggle(value)}>
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                  color="primary"
                />
              </ListItemIcon>
              {(value || value === 0) && team ? (
                <ListItemText
                  id={labelId}
                  primary={team.teamId ? team.channels[value].name : team.msGroups[value].name}
                  className="no-translate"
                />
              ) : null}
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Card>
  );

  return (
    <div className={classes.homeView}>
      <Header />
      {currentTeam ? <CardMedia className={classes.image} image={currentTeam.avatar} /> : null}
      <Typography component="h2" className={classes.title}>
        {currentTeam && currentTeam.teamId
          ? `Select Channels that would be Monitored by Sensla`
          : `Select Teams that would be Monitored by Sensla`}
      </Typography>
      {currentTeam && currentTeam.teamId && (
        <Alert severity="warning" className={classes.text}>
          {`Here you will only see your public channels. If you want to add Sensla in private channels you must go to Slack, go to the channel, press the "i" information in the upper right corner, then "more" (...) and finally "Add Apps". Here select Sensla`}
        </Alert>
      )}
      <Grid container spacing={3} justify="center" alignItems="center" className={classes.root}>
        <Grid item>
          {customList(currentTeam && currentTeam.teamId ? 'All Channels' : 'All Teams', left)}
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <Button
              variant="outlined"
              size="small"
              className={classes.button}
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              aria-label="move selected right"
            >
              &gt;
            </Button>
            <Button
              variant="outlined"
              size="small"
              className={classes.button}
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0}
              aria-label="move selected left"
            >
              &lt;
            </Button>
          </Grid>
        </Grid>
        <Grid item>
          {customList(
            currentTeam && currentTeam.teamId
              ? 'Channels to be monitored'
              : 'Teams to be monitored',
            right
          )}
        </Grid>
      </Grid>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.saveButton}
        onClick={handleSubmit}
      >
        Save
      </Button>
    </div>
  );
};

export { Preset };
